var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.037,
    height: 20.65,
    viewBox: "0 0 19.037 20.65",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-176 -425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,0H12.261l.323,3.227,2.9.323c.459,3.5-.139,5.459-2.049,8.381a7.913,7.913,0,0,0-1.5,5.171l1.049-.565.59-.318a6.646,6.646,0,0,0,1.911-1.7v6.13H0ZM4.84,5.485,4.3,6.151l-.746.625a4.773,4.773,0,0,1-1.613-.323l.645,1.291c1.047.11,1.047.11,1.835-.807l.746-.807Zm2.259,0V6.13h6.13V5.485ZM6.776,7.421l.323.645h6.13V7.421ZM1.936,10v3.227H5.162V10Zm5.162.323-.323.645H10.97v-.645Zm0,1.936v.645H10.97v-.645Zm-5.162,2.9c-.032.483-.042.968-.04,1.452l0,.8c-.03.654-.03.654.366.978.969.046,1.933.014,2.9,0V14.842A5.063,5.063,0,0,0,1.936,15.165Zm4.84.323.323.645H9.68v-.645ZM7.1,17.1l-.323.645h2.9V17.1Z",
    transform: "translate(176 425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-7.451,0A12.068,12.068,0,0,1-6.16.323,9.637,9.637,0,0,1-7.915,4.437l-.4.669C-9.3,6.733-9.3,6.733-10.032,7.1L-11,6.453A24.711,24.711,0,0,1-9.044,2.5l.356-.623C-7.819.368-7.819.368-7.451,0Z",
    transform: "translate(199.906 432.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M0,0H1.936V2.259H0Z",
    transform: "translate(178.581 440.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M0,0H1.936V1.936H0Z",
    transform: "translate(178.581 435.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-2.032,0-.741.323l-.323,1.613-.968.323L-3,1.291Z",
    transform: "translate(195.778 430.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M0,0A3.838,3.838,0,0,1,2.259,2.259H0Z",
    transform: "translate(188.906 425.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M0,0,1.291.323l-.323.968H0Z",
    transform: "translate(188.261 439.842)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIcon);
export default __webpack_public_path__ + "static/media/survey-icon.f51deea043bb156c96a46e36fd54cee3.svg";
export { ForwardRef as ReactComponent };